export const ActionTdWidth = 110;
export const ActionTdSmallWidth = 70;
export const DateTimeWidth = 150;
export const ReportDateWidth = 120;
export const RecurringDateWidth = 120;
export const DateWidth = 96;

export const NumberWidth = 120;
export const TypeWidth = 95;

export const ContactWidth = 150;
export const ReportContactWidth = 130;
export const ReportContactCodeWidth = 90;
